import { render, staticRenderFns } from "./GroupNewModal.vue?vue&type=template&id=7bec5dc0&scoped=true"
import script from "./GroupNewModal.vue?vue&type=script&lang=js"
export * from "./GroupNewModal.vue?vue&type=script&lang=js"
import style0 from "./GroupNewModal.vue?vue&type=style&index=0&id=7bec5dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bec5dc0",
  null
  
)

export default component.exports